import { Moon, Sun, SunMoon } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@cuspar/ui';
import { useTheme } from '../ThemeProvider';
import { useTranslation } from 'react-i18next';

export function ModeToggle() {
  const { t } = useTranslation();
  const { setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className='focus:ring-transparent focus-visible:ring-transparent' asChild>
        <Button variant='ghost' size='icon'>
          <Sun className='rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 h-5 w-5' />
          <Moon className='absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 h-5 w-5' />
          <span className='sr-only'>{t('common.toggleTheme')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem onClick={() => setTheme('light')}>
          <Sun className='mr-2 h-4 w-4' />
          {t('common.themeLight')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          <Moon className='mr-2 h-4 w-4' />
          {t('common.themeDark')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('system')}>
          <SunMoon className='mr-2 h-4 w-4' />
          {t('common.themeSystem')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
